import vText from "./v-text.vue";

export default Vue => {
  Vue.component("v-text", vText);
};
